import { DataGridPro, type GridColDef } from "@mui/x-data-grid-pro";
import { type FC } from "react";
import { EMPTY_ARRAY } from "src/utils/empty-values";
import { StoreAccountAssignment } from "../vc-account-assignments-types";

export interface AssignmentsTableProps {
  assignments?: StoreAccountAssignment[] | null;
  isLoading?: boolean;
}

const columns: GridColDef<StoreAccountAssignment>[] = [
  { field: "storeName", headerName: "Store Name", flex: 1 },
  {
    field: "accounts[0].accountName",
    headerName: "Account 1 Name",
    flex: 1,
    valueGetter: (_, row) => row.accounts[0].accountName,
  },
  {
    field: "accounts[0].email",
    headerName: "Account 1 Email",
    flex: 1,
    valueGetter: (_, row) => row.accounts[0].email,
  },
  {
    field: "accounts[1].accountName",
    headerName: "Account 2 Name",
    flex: 1,
    valueGetter: (_, row) => row.accounts[1].accountName,
  },
  {
    field: "accounts[1].email",
    headerName: "Account 2 Email",
    flex: 1,
    valueGetter: (_, row) => row.accounts[1].email,
  },
];

export const AssignmentsTable: FC<AssignmentsTableProps> = ({ assignments, isLoading }) => (
  <DataGridPro
    getRowId={row => row.storeName}
    columns={columns}
    rows={assignments || EMPTY_ARRAY}
    loading={isLoading}
    hideFooter
  />
);
